"use client"

import { ConvexProvider, ConvexReactClient } from "convex/react"
import { useMemo, type ReactNode } from "react"

type ConvexUrlProviderProps = {
  url: string
  children: ReactNode
}

export function ConvexUrlProvider({ url, children }: ConvexUrlProviderProps) {
  const client = useMemo(() => new ConvexReactClient(url), [url])
  return <ConvexProvider client={client}>{children}</ConvexProvider>
}
